import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
// import numeral from 'numeral';
// import moment from 'moment';

// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

// Actions
import { clientsActions } from '../actions/clients';

import Logo from '../assets/icon-120x120.png';
import HeaderPublic from '../components/HeaderPublic';
import Header from '../components/Header';
// import List from '../components/list'

// Assets: Brand logos
import brands_wharton from '../assets/brands/wharton_color.png';
import brands_kellogg from '../assets/brands/kellogg_v_white.png';
import brands_simcase from '../assets/brands/simcase.png';

class LibraryPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
    };

    // Bindings
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(clientsActions.getLibrary());
  }

  render() {
    const { items, loggedIn } = this.props;

    const colors = {
      negotiations: 'bg-primary',
      marketing: 'bg-success',
      management: 'bg-info',
      operations: 'bg-danger',
      math: 'bg-warning',
    };

    const clientsItems = items.map((client, ii) => {
      const name = client ? client.name : 'No name';
      const img =
        client && client.cover_url && client.cover_url.length > 0
          ? client.cover_url
          : Logo;
      const bgColor = client?.category
        ? colors[client.category]
        : 'bg-secondary';
      return (
        <div key={`inv-${client._id}`} className='col mb-4'>
          <div className='card card-primary h-100'>
            <div
              className={`card-header ${bgColor} text-white`}
              style={{ fontSize: '.8rem', padding: '7px 10px', lineHeight: 1 }}>
              <span className='float-left'>{client.duration} mins. </span>
              <span className='float-right text-capitalize'>
                {client.category}
              </span>
            </div>
            <div className='card-body text-center position-relative'>
              {client?.price === 0 ? (
                <span
                  className='badge badge-danger position-absolute'
                  style={{ top: '10px', right: '15px', fontSize: '1rem' }}>
                  FREE
                </span>
              ) : null}
              <img
                src={img}
                className='mt-4'
                style={{ width: '150px', height: '150px' }}
                alt={name}
              />
              <h4 className='mt-4 mb-4 fw-normal'>{name}</h4>
              <div>
                <p
                  className=''
                  dangerouslySetInnerHTML={{
                    __html: client ? client.description : '',
                  }}></p>
              </div>
              <Link
                to={'/library/' + (client.slug ? client.slug : client._id)}
                className='btn btn-md btn-outline-secondary mt-5 mb-4 stretched-link'>
                DETAILS
              </Link>
            </div>
          </div>
        </div>
      );
    });

    return (
      <div>
        {!loggedIn && <HeaderPublic />}
        {loggedIn && <Header />}

        <div className='row'>
          <div className='col-11 mx-auto'>
            {/* <hr /> */}

            {/* Brand logos & filters */}
            <div className='d-none text-center my-5 pb-4'>
              {/* <p className='lead'>Built with our partners.</p> */}

              <div className='d-flex justify-content-center align-items-center'>
                {/* Wharton */}
                <Link
                  to='/wharton'
                  className='d-flex align-items-center btn border align-self-stretch p-3 me-5'>
                  <img
                    src={brands_wharton}
                    alt='Wharton'
                    style={{ height: 'auto', maxWidth: '200px' }}
                  />
                </Link>
                {/* Kellogg */}
                <Link
                  to='/kellogg'
                  className='d-flex align-items-center btn border align-self-stretch p-3 me-5'>
                  <img
                    src={brands_kellogg}
                    alt='Kellogg'
                    style={{ height: 'auto', maxWidth: '200px' }}
                  />
                </Link>
                {/* SimCase */}
                <Link
                  to='/library'
                  className='d-flex align-items-center btn border align-self-stretch p-3 me-0'>
                  <img
                    src={brands_simcase}
                    alt='SimCase'
                    style={{ height: 'auto', maxWidth: '200px' }}
                  />
                </Link>
              </div>
            </div>

            <h3 className='text-center mt-5 mb-5 py-4 fs-2 fw-light'>
              What can we help you teach your students?
            </h3>

            {/* <hr /> */}

            <div className='row row-cols-1 row-cols-md-2 row-cols-lg-3 row-cols-xl-4 mt-5 mb-5'>
              {clientsItems}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { clients } = state;
  const { user, loggedIn } = state.authentication;
  return {
    user,
    loggedIn,
    items: clients.items,
  };
}

export default connect(mapStateToProps)(LibraryPage);
